"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.068 1.022a.612.612 0 1 1 0 1.224.612.612 0 0 1 0-1.224Zm3.17.854c.393 0 .712.314.722.704h1.556c.172 0 .312.139.312.31v12.796c0 .173-.14.312-.312.312H4.282V14.99h8.54V3.456H3.287v11.919h.003v.623h-.67a.312.312 0 0 1-.311-.312V2.89c0-.172.14-.311.312-.311h1.556a.72.72 0 0 1 .673-.699v-.005h1.604a1.634 1.634 0 1 1 3.23 0h1.555Zm-4.051 9.358a.543.543 0 0 0 .751-.117l2.905-4.05-.848-.586-2.607 3.697-1.413-1.062-.614.783 1.826 1.335Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.534a.919.919 0 1 1 .001 1.838A.919.919 0 0 1 12 1.534Zm4.756 1.282c.588 0 1.067.469 1.082 1.054h2.335c.258 0 .467.21.467.467v19.196a.467.467 0 0 1-.467.467H5.248v-1.114H19.52V5H4.485v18.065h.005V24h-.663a.468.468 0 0 1-.468-.467V4.337c0-.258.21-.467.468-.467h2.335a1.08 1.08 0 0 1 1.01-1.047v-.007h2.406a2.41 2.41 0 0 1-.031-.363 2.453 2.453 0 0 1 4.906 0c0 .123-.012.244-.03.363h2.333Zm-6.077 14.039a.796.796 0 0 0 .472.154.814.814 0 0 0 .654-.33l4.36-6.078-.91-.63-4.122 5.812-2.485-1.841-.708.91 2.739 2.003Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 2.045a1.225 1.225 0 1 1 .001 2.45A1.225 1.225 0 0 1 16 2.046Zm6.341 1.709c.784 0 1.423.626 1.444 1.406h3.113c.343 0 .622.28.622.623v25.594a.623.623 0 0 1-.622.623h-19.9v-1.485h19.028V6.667H5.98v24.086h.007V32h-.884a.624.624 0 0 1-.624-.623V5.783c0-.344.28-.623.624-.623h3.113a1.44 1.44 0 0 1 1.346-1.396v-.01h3.208a3.214 3.214 0 0 1-.041-.484 3.27 3.27 0 0 1 6.541 0c0 .165-.016.326-.04.484h3.111Zm-8.103 18.719c.19.139.41.206.63.206.33 0 .658-.152.872-.44l5.812-8.104-1.21-.84-5.498 7.749-3.313-2.455-.944 1.214 3.651 2.67Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.053 3.067a1.839 1.839 0 1 1 0 3.678 1.839 1.839 0 0 1 0-3.678Zm9.512 2.565c1.177 0 2.134.939 2.164 2.108h4.67c.517 0 .935.42.935.935v38.39a.935.935 0 0 1-.935.935H10.55v-1.87h28.916V9.61H8.642v36.52h.038V48h-.973a.935.935 0 0 1-.935-.935V8.675c0-.516.42-.935.935-.935h4.67a2.159 2.159 0 0 1 2.02-2.093v-.015h4.81a4.952 4.952 0 0 1-.06-.726 4.906 4.906 0 0 1 9.812 0c0 .247-.025.488-.06.726h4.666ZM21.411 33.709c.284.208.615.309.944.309.496 0 .987-.228 1.308-.661l8.717-12.155-1.519-1.09-8.558 11.934-5.266-3.852-1.103 1.51 5.477 4.005Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.071 4.09a2.451 2.451 0 1 1-.001 4.903 2.451 2.451 0 0 1 .001-4.903Zm12.683 3.419a2.887 2.887 0 0 1 2.885 2.811h6.226c.69 0 1.247.559 1.247 1.247v51.187c0 .688-.558 1.246-1.247 1.246h-39.8v-2.493H52.62V12.813H11.522v48.694h.051V64h-1.297a1.247 1.247 0 0 1-1.246-1.246V11.567c0-.688.558-1.247 1.246-1.247h6.227a2.878 2.878 0 0 1 2.692-2.791v-.02h6.415a6.589 6.589 0 0 1-.08-.968 6.54 6.54 0 0 1 13.082 0c0 .33-.033.65-.08.968h6.222ZM28.548 44.946c.379.277.82.411 1.259.411.661 0 1.316-.304 1.744-.881l11.622-16.207-2.025-1.453-11.41 15.912-7.022-5.136-1.47 2.012 7.302 5.342Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconClaims = function IconClaims(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Claims' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Claims"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconClaims.sizes = [16, 24, 32, 48, 64];
IconClaims.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconClaims;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Claims.js
// module id = 1689
// module chunks = 0